import { Injectable } from '@angular/core';
import { NgForm } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class DirtyFormRegistrationService {
  private readonly forms: Set<NgForm>;

  private lastCallbackId: number;

  private readonly callbacks: {
    [key: number]: () => boolean;
  };

  constructor() {
    this.forms = new Set<NgForm>();
    this.lastCallbackId = 0;
    this.callbacks = {};
  }

  isDirty(): boolean {
    let dirty = false;
    for (const form of this.forms) {
      if (form.dirty) {
        dirty = true;
        break;
      }
    }
    if (!dirty) {
      for (const callback of Object.values(this.callbacks)) {
        if (callback()) {
          dirty = true;
          break;
        }
      }
    }
    return dirty;
  }

  registerForm(form: NgForm | null | undefined) {
    if (form == null) {
      console.error('Trying to add form that is null or undefined');
      return;
    }
    this.forms.add(form);
  }

  deregisterForm(form: NgForm | null | undefined) {
    if (form == null) {
      console.error('Trying to delete form that is null or undefined');
      return;
    }
    this.forms.delete(form);
  }

  registerCallback(callback: () => boolean): number {
    const callbackId = this.lastCallbackId++;
    this.callbacks[callbackId] = callback;
    return callbackId;
  }

  deregisterCallback(callbackId: number) {
    delete this.callbacks[callbackId];
  }
}
